
import React from 'react'

import AudioButton from './AudioButton'
import QuizInput from './QuizInput'

import './QuizElement.css'
import coverPlaceholder from '../Resources/cover-placeholder.png'


const QuizElement = ({ index, sound, playAudio, handleCheck }) => (
<div className='Quiz-element'>
	<div className='Quiz-element-content'>
		<div className='meta-data'>
			<div>
				<span className='Quiz-element-index'>{index}.</span>
				<AudioButton id={sound.id} playAudio={playAudio} correct={sound.correct} />
			</div>
				{sound.game && sound.cover_url ? (
					<img className='cover-art' src={sound.cover_url} alt={`Cover von ${sound.game}`} loading='lazy' />
				) : (
					<img className='cover-art' src={coverPlaceholder} alt='Cover noch nicht aufgedeckt' />
				)}
			<span className='release-year'>Release:<br/>
			{sound.game && sound.release_year ? (
				sound.release_year
			) : (
				'????'
			)}
			</span>
		</div>
		<QuizInput sound={sound} handleCheck={handleCheck} />
	</div>
</div>
)

export default QuizElement
